import React from 'react'
import {useGameStore} from '../../store/GameStoreContext.ts'
import {UIGameReplayControls} from './UIGameReplayControls.tsx'

export const UIGameReplayControlsContainer = ({
    useMinimalControls,
    disableTooltips,
}: {
    useMinimalControls: boolean
    disableTooltips?: boolean | undefined
}) => {
    const userStates = useGameStore((state) => state.gameUserStates.userStates)
    const actionIndex = useGameStore((state) => state.gameReplay.actionIndex)
    const replayControls = useGameStore((state) => state.gameReplay.replayControls)

    if(replayControls == undefined) {
        return null
    }

    return <UIGameReplayControls
        useMinimalReplayControls={useMinimalControls}
        currentActionIndex={actionIndex}
        playerUserStates={userStates}
        disableTooltips={disableTooltips}
        {...replayControls} />
}
